import React, { useState, useEffect, useContext } from 'react';
import { texts } from './serviciosAtencionCiudadaniaData';
import { properties as appProperties, texts as appTexts } from '../../../AppData';
import { Grid  } from '@material-ui/core';
import { customStyle } from './serviciosAtencionCiudadaniaStyle';
import PersonIcon from '@material-ui/icons/Person';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import AppContext from 'AppContext';
import {properties as propertiesCloudConfig } from '../../../config/Config';
import AuthProvider from './../../../providers/authProvider';

function ServiciosAtencionCiudadania() {

    //HOOKS
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const context = useContext(AppContext);
    const {checkCloudProperties} = AuthProvider();
    const [mailProcCTDIIUE, setMailProcCTDIIUE] = useState();
    const [mailProcComercioOtros, setMailProcComercioOtros] = useState();
    const [mailProcIndustriaMinas, setMailProcIndustriaMinas] = useState();
    const [tlfProcCTDIIUE, setTlfProcCTDIIUE] = useState();
    const [tlfProcComercioOtros, setTlfProcComercioOtros] = useState();
    const [tlfProcIndustriaMinas, setTlfProcIndustriaMinas] = useState();

    //LLAMADAS
    useEffect(() => {
        loadCloudInfo();
        updateFormat();
        context.updateTitlePage(texts.PAGE_TITLE);
    }, []);

    //FUNCIONES

    const loadCloudInfo = async () => {
        await checkCloudProperties(100);

        // MAIL
        setMailProcCTDIIUE(propertiesCloudConfig['PROCEDIMIENTOS_CTDIIUE_MAIL']);
        setMailProcComercioOtros(propertiesCloudConfig['PROCEDIMIENTOS_COMERCIO_OTROS_MAIL']);
        setMailProcIndustriaMinas(propertiesCloudConfig['PROCEDIMIENTOS_INDUSTRIA_MINAS_MAIL']);

        // TLF
        setTlfProcCTDIIUE(propertiesCloudConfig['TELEFONO_SAC_UNIVERSIDADES']);
        setTlfProcComercioOtros(propertiesCloudConfig['TELEFONO_SAC_COMERCIO']);
        setTlfProcIndustriaMinas(propertiesCloudConfig['TELEFONO_SAC_INDUSTRIA']);
    }

    /**Método que capta el tamaño de la ventana y actualiza actualiza
    ***el hook que controla cuando se da el salto a versión movil*/
    const updateFormat = () => {
        if (window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    };


    //RENDER

    return (
        <main>
            <Grid container direction='column' justify='space-around'>
                <Grid direction={isPhoneVersion ? 'column-reverse' : 'row'} justify='space-between'>
                    <Grid container className={customStyle().gridPageTitle}>
                        <h2 className={customStyle().classTitleH2} id="tituloPagina">{texts.PAGE_TITLE}</h2>
                    </Grid>
                </Grid>
                <Grid className={customStyle().backgroundRectangle}>
                    <Grid container direction='row'  justify='space-around'>                        
                        
                        {/* Grid contenedor de contactos de cada procedimiento*/}
                        <Grid className={customStyle().classGridContainerContactos}>
                            <Grid className={customStyle().classGridContactos}>
                                <h5 className={customStyle().classTitleH5}>Atención a la ciudadanía para procedimientos de Empresa Digital, Infraestructura de Telecomunicaciones, Investigación e innovación y Universidades</h5>
                                <ul item className={ isPhoneVersion ? customStyle().gridTableResponsivePager : customStyle().classUl} >
                                    <p><FiberManualRecordIcon fontSize="inherit" color="action"></FiberManualRecordIcon>&nbsp;&nbsp;&nbsp;E-mail: <a target="_blank" className={customStyle().classLink} href={"mailto:" + mailProcCTDIIUE}>{mailProcCTDIIUE}</a></p>
                                    <br></br><p><FiberManualRecordIcon fontSize="inherit" color="action"></FiberManualRecordIcon>&nbsp;&nbsp;&nbsp;Tfno: {tlfProcCTDIIUE}</p>
                                </ul>
                            </Grid>
                            <Grid className={customStyle().classGridContactos}>
                                <h5 className={customStyle().classTitleH5}>Atención a la ciudadanía para procedimientos de Comercio y Otros</h5>
                                <ul item className={ isPhoneVersion ? customStyle().gridTableResponsivePager : customStyle().classUl} >
                                    <p><FiberManualRecordIcon fontSize="inherit" color="action"></FiberManualRecordIcon>&nbsp;&nbsp;&nbsp;E-mail: <a target="_blank" className={customStyle().classLink} href={"mailto:" + mailProcComercioOtros}>{mailProcComercioOtros}</a></p>
                                    <br></br><p><FiberManualRecordIcon fontSize="inherit" color="action"></FiberManualRecordIcon>&nbsp;&nbsp;&nbsp;Tfno: {tlfProcComercioOtros}</p>
                                </ul>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>

        </main>
    )

}

export default ServiciosAtencionCiudadania